module.exports = __webpack_public_path__ + "static/media/hot64.5155910e.jpg";